import type { User } from "../types";

export const isAdmin = (user: User | null) =>
  user !== null && user.admin === true;

export const isUser = (user: User | null) => user !== null && !isAdmin(user);

export const isGuest = (user: User | null) => user === null;
